import React from 'react';
import ComponentCreator from '@docusaurus/ComponentCreator';

export default [
  {
    path: '/search/',
    component: ComponentCreator('/search/', '050'),
    exact: true
  },
  {
    path: '/concepts/',
    component: ComponentCreator('/concepts/', '1f6'),
    routes: [
      {
        path: '/concepts/',
        component: ComponentCreator('/concepts/', 'c85'),
        exact: true,
        sidebar: "someSidebar"
      },
      {
        path: '/concepts/credential-issuance-lifecycle/',
        component: ComponentCreator('/concepts/credential-issuance-lifecycle/', 'bf0'),
        exact: true,
        sidebar: "someSidebar"
      },
      {
        path: '/concepts/data-agreements-versions/',
        component: ComponentCreator('/concepts/data-agreements-versions/', '758'),
        exact: true,
        sidebar: "someSidebar"
      },
      {
        path: '/concepts/data-agreements/',
        component: ComponentCreator('/concepts/data-agreements/', '673'),
        exact: true,
        sidebar: "someSidebar"
      },
      {
        path: '/concepts/data-disclosure-agreements-versions/',
        component: ComponentCreator('/concepts/data-disclosure-agreements-versions/', '17b'),
        exact: true,
        sidebar: "someSidebar"
      },
      {
        path: '/concepts/data-disclosure-agreements/',
        component: ComponentCreator('/concepts/data-disclosure-agreements/', 'ae1'),
        exact: true,
        sidebar: "someSidebar"
      },
      {
        path: '/concepts/data-exchange-landscape/',
        component: ComponentCreator('/concepts/data-exchange-landscape/', '7c1'),
        exact: true,
        sidebar: "someSidebar"
      },
      {
        path: '/concepts/dataexchange-agreements-ieee-paper/',
        component: ComponentCreator('/concepts/dataexchange-agreements-ieee-paper/', '81a'),
        exact: true,
        sidebar: "someSidebar"
      },
      {
        path: '/concepts/disp-overview/',
        component: ComponentCreator('/concepts/disp-overview/', '409'),
        exact: true,
        sidebar: "someSidebar"
      },
      {
        path: '/concepts/eidas/eidas-main/',
        component: ComponentCreator('/concepts/eidas/eidas-main/', 'c57'),
        exact: true
      },
      {
        path: '/concepts/eidas2-and-digital-wallets/',
        component: ComponentCreator('/concepts/eidas2-and-digital-wallets/', '2a9'),
        exact: true,
        sidebar: "someSidebar"
      },
      {
        path: '/concepts/eu-digital-identity-eudi-wallet-business-benefits-use-cases-eidas/',
        component: ComponentCreator('/concepts/eu-digital-identity-eudi-wallet-business-benefits-use-cases-eidas/', 'bea'),
        exact: true,
        sidebar: "someSidebar"
      },
      {
        path: '/concepts/eudi-wallet-dcql-openid4vp-business-wallet-payments/',
        component: ComponentCreator('/concepts/eudi-wallet-dcql-openid4vp-business-wallet-payments/', '176'),
        exact: true,
        sidebar: "someSidebar"
      },
      {
        path: '/concepts/eudi-wallet-verifiable-credential-formats/',
        component: ComponentCreator('/concepts/eudi-wallet-verifiable-credential-formats/', '0a7'),
        exact: true,
        sidebar: "someSidebar"
      },
      {
        path: '/concepts/european-business-wallets/',
        component: ComponentCreator('/concepts/european-business-wallets/', '83a'),
        exact: true,
        sidebar: "someSidebar"
      },
      {
        path: '/concepts/mdoDocs/mdo-main/',
        component: ComponentCreator('/concepts/mdoDocs/mdo-main/', 'e17'),
        exact: true
      },
      {
        path: '/concepts/mdoDocs/mdo-mobagents/',
        component: ComponentCreator('/concepts/mdoDocs/mdo-mobagents/', 'd2d'),
        exact: true
      },
      {
        path: '/concepts/mdoDocs/mdo-pdd/',
        component: ComponentCreator('/concepts/mdoDocs/mdo-pdd/', '0a2'),
        exact: true
      },
      {
        path: '/concepts/mdoDocs/mdo-ref-model/',
        component: ComponentCreator('/concepts/mdoDocs/mdo-ref-model/', '409'),
        exact: true,
        sidebar: "someSidebar"
      },
      {
        path: '/concepts/openID4vc/',
        component: ComponentCreator('/concepts/openID4vc/', 'ea2'),
        exact: true,
        sidebar: "someSidebar"
      },
      {
        path: '/concepts/openid4vci-credential-issuance/',
        component: ComponentCreator('/concepts/openid4vci-credential-issuance/', 'e57'),
        exact: true,
        sidebar: "someSidebar"
      },
      {
        path: '/concepts/openid4vp-credential-verification/',
        component: ComponentCreator('/concepts/openid4vp-credential-verification/', 'eb6'),
        exact: true,
        sidebar: "someSidebar"
      },
      {
        path: '/concepts/revocation-chaining/',
        component: ComponentCreator('/concepts/revocation-chaining/', 'e03'),
        exact: true,
        sidebar: "someSidebar"
      },
      {
        path: '/concepts/wallet-secure-cryptographic-application-device/',
        component: ComponentCreator('/concepts/wallet-secure-cryptographic-application-device/', '105'),
        exact: true,
        sidebar: "someSidebar"
      },
      {
        path: '/concepts/wallet-unit-attestation/',
        component: ComponentCreator('/concepts/wallet-unit-attestation/', '7c1'),
        exact: true,
        sidebar: "someSidebar"
      },
      {
        path: '/concepts/what-is-the-eu-digital-identity-wallet/',
        component: ComponentCreator('/concepts/what-is-the-eu-digital-identity-wallet/', '32b'),
        exact: true,
        sidebar: "someSidebar"
      }
    ]
  },
  {
    path: '/docs/',
    component: ComponentCreator('/docs/', '7de'),
    routes: [
      {
        path: '/docs/',
        component: ComponentCreator('/docs/', '83a'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/abbreviations/',
        component: ComponentCreator('/docs/abbreviations/', 'ddf'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/agent-skills-catalogue/',
        component: ComponentCreator('/docs/agent-skills-catalogue/', '470'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/agent-skills/',
        component: ComponentCreator('/docs/agent-skills/', '389'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/category/consent-management-admin-api/audit/',
        component: ComponentCreator('/docs/category/consent-management-admin-api/audit/', '8aa'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/category/consent-management-admin-api/data-agreement/',
        component: ComponentCreator('/docs/category/consent-management-admin-api/data-agreement/', '2f3'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/category/consent-management-admin-api/data-attribute/',
        component: ComponentCreator('/docs/category/consent-management-admin-api/data-attribute/', '5f8'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/category/consent-management-admin-api/data-policy/',
        component: ComponentCreator('/docs/category/consent-management-admin-api/data-policy/', 'fac'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/category/consent-management-admin-api/individual/',
        component: ComponentCreator('/docs/category/consent-management-admin-api/individual/', 'f03'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/category/consent-management-admin-api/webhook/',
        component: ComponentCreator('/docs/category/consent-management-admin-api/webhook/', '014'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/category/consent-management-individual-api/consent-record/',
        component: ComponentCreator('/docs/category/consent-management-individual-api/consent-record/', 'f05'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/category/consent-management-individual-api/data-agreement/',
        component: ComponentCreator('/docs/category/consent-management-individual-api/data-agreement/', '112'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/category/consent-management-individual-api/data-policy/',
        component: ComponentCreator('/docs/category/consent-management-individual-api/data-policy/', '927'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/category/consent-management-individual-api/data-sharing/',
        component: ComponentCreator('/docs/category/consent-management-individual-api/data-sharing/', '6f4'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/category/consent-management-individual-api/identity-provider/',
        component: ComponentCreator('/docs/category/consent-management-individual-api/identity-provider/', 'b15'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/category/consent-management-individual-api/organisation/',
        component: ComponentCreator('/docs/category/consent-management-individual-api/organisation/', '1f5'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/category/consent-management-individual-api/verification/',
        component: ComponentCreator('/docs/category/consent-management-individual-api/verification/', '3c1'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/category/datamarketplace-api/access-logs/',
        component: ComponentCreator('/docs/category/datamarketplace-api/access-logs/', '444'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/category/datamarketplace-api/base-configurations/',
        component: ComponentCreator('/docs/category/datamarketplace-api/base-configurations/', 'd98'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/category/datamarketplace-api/data-disclosure-agreements/',
        component: ComponentCreator('/docs/category/datamarketplace-api/data-disclosure-agreements/', 'ae9'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/category/datamarketplace-api/signed-agreements/',
        component: ComponentCreator('/docs/category/datamarketplace-api/signed-agreements/', 'c06'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/category/datamarketplace-api/webhook/',
        component: ComponentCreator('/docs/category/datamarketplace-api/webhook/', '5b7'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/category/datamarketplace-individual-api/authorisation-server/',
        component: ComponentCreator('/docs/category/datamarketplace-individual-api/authorisation-server/', '34d'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/category/datamarketplace-individual-api/data-disclosure-agreements/',
        component: ComponentCreator('/docs/category/datamarketplace-individual-api/data-disclosure-agreements/', '84d'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/category/datamarketplace-individual-api/signed-agreements/',
        component: ComponentCreator('/docs/category/datamarketplace-individual-api/signed-agreements/', '488'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/category/drv-bund-api/authentication/',
        component: ComponentCreator('/docs/category/drv-bund-api/authentication/', 'aa7'),
        exact: true,
        sidebar: "drvBundSidebar"
      },
      {
        path: '/docs/category/drv-bund-api/upload-attestation-data/',
        component: ComponentCreator('/docs/category/drv-bund-api/upload-attestation-data/', 'df0'),
        exact: true,
        sidebar: "drvBundSidebar"
      },
      {
        path: '/docs/category/extensions-api/account-information-access/',
        component: ComponentCreator('/docs/category/extensions-api/account-information-access/', 'bff'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/category/extensions-api/age-verification/',
        component: ComponentCreator('/docs/category/extensions-api/age-verification/', 'f15'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/category/extensions-api/document-signing/',
        component: ComponentCreator('/docs/category/extensions-api/document-signing/', '733'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/category/extensions-api/know-your-customer/',
        component: ComponentCreator('/docs/category/extensions-api/know-your-customer/', 'c89'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/category/extensions-api/manage-extension/',
        component: ComponentCreator('/docs/category/extensions-api/manage-extension/', 'fa7'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/category/extensions-api/open-id-connect-client/',
        component: ComponentCreator('/docs/category/extensions-api/open-id-connect-client/', 'f77'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/category/extensions-api/open-id-provider-main-tenant/',
        component: ComponentCreator('/docs/category/extensions-api/open-id-provider-main-tenant/', '097'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/category/extensions-api/open-id-provider-sandbox-organisation/',
        component: ComponentCreator('/docs/category/extensions-api/open-id-provider-sandbox-organisation/', '152'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/category/extensions-api/payment-authorisation-for-banks/',
        component: ComponentCreator('/docs/category/extensions-api/payment-authorisation-for-banks/', 'a20'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/category/extensions-api/payment-authorisation-for-merchants/',
        component: ComponentCreator('/docs/category/extensions-api/payment-authorisation-for-merchants/', 'a3c'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/category/extensions-api/payment-credential-issuance/',
        component: ComponentCreator('/docs/category/extensions-api/payment-credential-issuance/', '3fa'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/category/extensions-api/photo-id-credential-issuance/',
        component: ComponentCreator('/docs/category/extensions-api/photo-id-credential-issuance/', 'd21'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/category/extensions-api/pid-credential-issuance/',
        component: ComponentCreator('/docs/category/extensions-api/pid-credential-issuance/', 'bc5'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/category/extensions-api/recurring-payment-mandate/',
        component: ComponentCreator('/docs/category/extensions-api/recurring-payment-mandate/', 'a91'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/category/extensions-api/risk-based-authentication/',
        component: ComponentCreator('/docs/category/extensions-api/risk-based-authentication/', '6b6'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/category/openid4vc-api/holder/',
        component: ComponentCreator('/docs/category/openid4vc-api/holder/', 'd7a'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/category/openid4vc-api/issuer/',
        component: ComponentCreator('/docs/category/openid4vc-api/issuer/', '6bc'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/category/openid4vc-api/key-management/',
        component: ComponentCreator('/docs/category/openid4vc-api/key-management/', 'fd0'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/category/openid4vc-api/sandboxes/',
        component: ComponentCreator('/docs/category/openid4vc-api/sandboxes/', 'ac4'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/category/openid4vc-api/trust-anchor/',
        component: ComponentCreator('/docs/category/openid4vc-api/trust-anchor/', 'c2e'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/category/openid4vc-api/user-management/',
        component: ComponentCreator('/docs/category/openid4vc-api/user-management/', '32d'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/category/openid4vc-api/verifier/',
        component: ComponentCreator('/docs/category/openid4vc-api/verifier/', '5ce'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/category/openid4vc-api/wallet-provider/',
        component: ComponentCreator('/docs/category/openid4vc-api/wallet-provider/', '224'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/category/openid4vc-api/webhook/',
        component: ComponentCreator('/docs/category/openid4vc-api/webhook/', 'fc7'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/changelog/2026-q1/',
        component: ComponentCreator('/docs/changelog/2026-q1/', 'bc0'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/changelog/2026-q2/',
        component: ComponentCreator('/docs/changelog/2026-q2/', '12e'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/changelog/2026-q3/',
        component: ComponentCreator('/docs/changelog/2026-q3/', 'b6a'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/consent-management-admin-api/audit-consent-record-read/',
        component: ComponentCreator('/docs/consent-management-admin-api/audit-consent-record-read/', 'cfd'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/consent-management-admin-api/audit-data-agreement-list/',
        component: ComponentCreator('/docs/consent-management-admin-api/audit-data-agreement-list/', 'e59'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/consent-management-admin-api/audit-data-agreement-records-list/',
        component: ComponentCreator('/docs/consent-management-admin-api/audit-data-agreement-records-list/', 'dbb'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/consent-management-admin-api/audit-read-record/',
        component: ComponentCreator('/docs/consent-management-admin-api/audit-read-record/', 'e07'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/consent-management-admin-api/config-create-agreement/',
        component: ComponentCreator('/docs/consent-management-admin-api/config-create-agreement/', '8e1'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/consent-management-admin-api/config-create-individual/',
        component: ComponentCreator('/docs/consent-management-admin-api/config-create-individual/', '7f0'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/consent-management-admin-api/config-create-policy/',
        component: ComponentCreator('/docs/consent-management-admin-api/config-create-policy/', '7b5'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/consent-management-admin-api/config-create-webhook/',
        component: ComponentCreator('/docs/consent-management-admin-api/config-create-webhook/', 'cbb'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/consent-management-admin-api/config-delete-agreement/',
        component: ComponentCreator('/docs/consent-management-admin-api/config-delete-agreement/', '3b7'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/consent-management-admin-api/config-delete-policy/',
        component: ComponentCreator('/docs/consent-management-admin-api/config-delete-policy/', 'aec'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/consent-management-admin-api/config-delete-webhook/',
        component: ComponentCreator('/docs/consent-management-admin-api/config-delete-webhook/', '342'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/consent-management-admin-api/config-list-agreement-revisions/',
        component: ComponentCreator('/docs/consent-management-admin-api/config-list-agreement-revisions/', 'f49'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/consent-management-admin-api/config-list-agreement/',
        component: ComponentCreator('/docs/consent-management-admin-api/config-list-agreement/', 'b89'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/consent-management-admin-api/config-list-data-attribute/',
        component: ComponentCreator('/docs/consent-management-admin-api/config-list-data-attribute/', 'b72'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/consent-management-admin-api/config-list-individuals/',
        component: ComponentCreator('/docs/consent-management-admin-api/config-list-individuals/', 'bf4'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/consent-management-admin-api/config-list-policy-revisions/',
        component: ComponentCreator('/docs/consent-management-admin-api/config-list-policy-revisions/', '303'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/consent-management-admin-api/config-list-policy/',
        component: ComponentCreator('/docs/consent-management-admin-api/config-list-policy/', '9a7'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/consent-management-admin-api/config-list-webhooks/',
        component: ComponentCreator('/docs/consent-management-admin-api/config-list-webhooks/', '909'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/consent-management-admin-api/config-read-agreement/',
        component: ComponentCreator('/docs/consent-management-admin-api/config-read-agreement/', '863'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/consent-management-admin-api/config-read-individual/',
        component: ComponentCreator('/docs/consent-management-admin-api/config-read-individual/', 'dfa'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/consent-management-admin-api/config-read-policy/',
        component: ComponentCreator('/docs/consent-management-admin-api/config-read-policy/', 'caa'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/consent-management-admin-api/config-read-webhook-event-types/',
        component: ComponentCreator('/docs/consent-management-admin-api/config-read-webhook-event-types/', '82c'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/consent-management-admin-api/config-read-webhook/',
        component: ComponentCreator('/docs/consent-management-admin-api/config-read-webhook/', '6e9'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/consent-management-admin-api/config-update-agreement/',
        component: ComponentCreator('/docs/consent-management-admin-api/config-update-agreement/', '191'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/consent-management-admin-api/config-update-data-attribute/',
        component: ComponentCreator('/docs/consent-management-admin-api/config-update-data-attribute/', '994'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/consent-management-admin-api/config-update-individual/',
        component: ComponentCreator('/docs/consent-management-admin-api/config-update-individual/', '5c2'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/consent-management-admin-api/config-update-policy/',
        component: ComponentCreator('/docs/consent-management-admin-api/config-update-policy/', '582'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/consent-management-admin-api/config-update-webhook/',
        component: ComponentCreator('/docs/consent-management-admin-api/config-update-webhook/', '683'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/consent-management-admin-api/get-webhook-payload-content-types/',
        component: ComponentCreator('/docs/consent-management-admin-api/get-webhook-payload-content-types/', 'cff'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/consent-management-admin-api/igrant-io-api-documentation/',
        component: ComponentCreator('/docs/consent-management-admin-api/igrant-io-api-documentation/', 'f67'),
        exact: true
      },
      {
        path: '/docs/consent-management-admin-guide/',
        component: ComponentCreator('/docs/consent-management-admin-guide/', '55b'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/consent-management-apis/',
        component: ComponentCreator('/docs/consent-management-apis/', '957'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/consent-management-individual-api/config-create-policy/',
        component: ComponentCreator('/docs/consent-management-individual-api/config-create-policy/', 'dcb'),
        exact: true
      },
      {
        path: '/docs/consent-management-individual-api/config-read-individual/',
        component: ComponentCreator('/docs/consent-management-individual-api/config-read-individual/', '7e9'),
        exact: true
      },
      {
        path: '/docs/consent-management-individual-api/config-update-individual/',
        component: ComponentCreator('/docs/consent-management-individual-api/config-update-individual/', '8fe'),
        exact: true
      },
      {
        path: '/docs/consent-management-individual-api/igrant-io-api-documentation/',
        component: ComponentCreator('/docs/consent-management-individual-api/igrant-io-api-documentation/', '083'),
        exact: true
      },
      {
        path: '/docs/consent-management-individual-api/service-agreement-data-read/',
        component: ComponentCreator('/docs/consent-management-individual-api/service-agreement-data-read/', '30e'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/consent-management-individual-api/service-agreement-list/',
        component: ComponentCreator('/docs/consent-management-individual-api/service-agreement-list/', '76f'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/consent-management-individual-api/service-agreement-read/',
        component: ComponentCreator('/docs/consent-management-individual-api/service-agreement-read/', 'e55'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/consent-management-individual-api/service-create-individual-consent-record-and-signature/',
        component: ComponentCreator('/docs/consent-management-individual-api/service-create-individual-consent-record-and-signature/', 'be6'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/consent-management-individual-api/service-create-individual-consent-record-draft/',
        component: ComponentCreator('/docs/consent-management-individual-api/service-create-individual-consent-record-draft/', 'e90'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/consent-management-individual-api/service-create-individual-consent-record-signature/',
        component: ComponentCreator('/docs/consent-management-individual-api/service-create-individual-consent-record-signature/', 'ce9'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/consent-management-individual-api/service-create-individual-consent-record/',
        component: ComponentCreator('/docs/consent-management-individual-api/service-create-individual-consent-record/', '3ec'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/consent-management-individual-api/service-delete-all-records/',
        component: ComponentCreator('/docs/consent-management-individual-api/service-delete-all-records/', '5bc'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/consent-management-individual-api/service-list-data-agreement-record-history/',
        component: ComponentCreator('/docs/consent-management-individual-api/service-list-data-agreement-record-history/', 'ea9'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/consent-management-individual-api/service-list-individual-agreement-consent-record-list/',
        component: ComponentCreator('/docs/consent-management-individual-api/service-list-individual-agreement-consent-record-list/', 'd03'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/consent-management-individual-api/service-list-individual-consent-record-list/',
        component: ComponentCreator('/docs/consent-management-individual-api/service-list-individual-consent-record-list/', '559'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/consent-management-individual-api/service-list-individuals/',
        component: ComponentCreator('/docs/consent-management-individual-api/service-list-individuals/', 'b23'),
        exact: true
      },
      {
        path: '/docs/consent-management-individual-api/service-policy-read/',
        component: ComponentCreator('/docs/consent-management-individual-api/service-policy-read/', '72a'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/consent-management-individual-api/service-read-data-sharing-ui/',
        component: ComponentCreator('/docs/consent-management-individual-api/service-read-data-sharing-ui/', '032'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/consent-management-individual-api/service-read-idp/',
        component: ComponentCreator('/docs/consent-management-individual-api/service-read-idp/', 'e2e'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/consent-management-individual-api/service-read-individual-record-read/',
        component: ComponentCreator('/docs/consent-management-individual-api/service-read-individual-record-read/', '464'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/consent-management-individual-api/service-read-organisation-cover-image/',
        component: ComponentCreator('/docs/consent-management-individual-api/service-read-organisation-cover-image/', '3e9'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/consent-management-individual-api/service-read-organisation-image/',
        component: ComponentCreator('/docs/consent-management-individual-api/service-read-organisation-image/', 'a9a'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/consent-management-individual-api/service-read-organisation-logo-image/',
        component: ComponentCreator('/docs/consent-management-individual-api/service-read-organisation-logo-image/', '0a6'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/consent-management-individual-api/service-read-organisation/',
        component: ComponentCreator('/docs/consent-management-individual-api/service-read-organisation/', '45d'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/consent-management-individual-api/service-update-individual-consent-record-signature/',
        component: ComponentCreator('/docs/consent-management-individual-api/service-update-individual-consent-record-signature/', 'ca2'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/consent-management-individual-api/service-update-individual-consent-record/',
        component: ComponentCreator('/docs/consent-management-individual-api/service-update-individual-consent-record/', 'b1f'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/consent-management-individual-api/service-verification-agreement-consent-record-read/',
        component: ComponentCreator('/docs/consent-management-individual-api/service-verification-agreement-consent-record-read/', '54d'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/consent-management-individual-api/service-verification-agreement-list/',
        component: ComponentCreator('/docs/consent-management-individual-api/service-verification-agreement-list/', '651'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/consent-management-individual-api/service-verification-consent-record-list/',
        component: ComponentCreator('/docs/consent-management-individual-api/service-verification-consent-record-list/', '8e4'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/consent-management-overview/',
        component: ComponentCreator('/docs/consent-management-overview/', '61d'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/consent-management-sdks/',
        component: ComponentCreator('/docs/consent-management-sdks/', 'bae'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/data-intermediation-service-provider-apis/',
        component: ComponentCreator('/docs/data-intermediation-service-provider-apis/', 'b33'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/data-intermediation-service-provider-overview/',
        component: ComponentCreator('/docs/data-intermediation-service-provider-overview/', '3f2'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/data-wallet-features/',
        component: ComponentCreator('/docs/data-wallet-features/', 'bae'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/data-wallet-openID4vc-sdks/',
        component: ComponentCreator('/docs/data-wallet-openID4vc-sdks/', '398'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/data-wallet-overview/',
        component: ComponentCreator('/docs/data-wallet-overview/', '33a'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/data-wallet-sdks/',
        component: ComponentCreator('/docs/data-wallet-sdks/', 'a21'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/data-wallet-tryitout/',
        component: ComponentCreator('/docs/data-wallet-tryitout/', 'c10'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/datamarketplace-api/config-create-webhook/',
        component: ComponentCreator('/docs/datamarketplace-api/config-create-webhook/', '7f2'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/datamarketplace-api/config-delete-webhook/',
        component: ComponentCreator('/docs/datamarketplace-api/config-delete-webhook/', 'dd7'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/datamarketplace-api/config-list-webhooks/',
        component: ComponentCreator('/docs/datamarketplace-api/config-list-webhooks/', '74f'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/datamarketplace-api/config-read-webhook-event-types/',
        component: ComponentCreator('/docs/datamarketplace-api/config-read-webhook-event-types/', '5e3'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/datamarketplace-api/config-read-webhook/',
        component: ComponentCreator('/docs/datamarketplace-api/config-read-webhook/', '673'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/datamarketplace-api/config-update-webhook/',
        component: ComponentCreator('/docs/datamarketplace-api/config-update-webhook/', '199'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/datamarketplace-api/create-base-configurations/',
        component: ComponentCreator('/docs/datamarketplace-api/create-base-configurations/', 'd5f'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/datamarketplace-api/create-data-disclosure-agreement-template/',
        component: ComponentCreator('/docs/datamarketplace-api/create-data-disclosure-agreement-template/', '75b'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/datamarketplace-api/create-o-auth-2-0-client/',
        component: ComponentCreator('/docs/datamarketplace-api/create-o-auth-2-0-client/', '8a5'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/datamarketplace-api/delete-base-configurations/',
        component: ComponentCreator('/docs/datamarketplace-api/delete-base-configurations/', 'a07'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/datamarketplace-api/delete-data-disclosure-agreement-template/',
        component: ComponentCreator('/docs/datamarketplace-api/delete-data-disclosure-agreement-template/', 'd7e'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/datamarketplace-api/delete-o-auth-2-0-client/',
        component: ComponentCreator('/docs/datamarketplace-api/delete-o-auth-2-0-client/', '25d'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/datamarketplace-api/get-webhook-payload-content-types/',
        component: ComponentCreator('/docs/datamarketplace-api/get-webhook-payload-content-types/', 'a54'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/datamarketplace-api/igrant-io-api-documentation/',
        component: ComponentCreator('/docs/datamarketplace-api/igrant-io-api-documentation/', 'c6a'),
        exact: true
      },
      {
        path: '/docs/datamarketplace-api/list-all-data-disclosure-agreement-records/',
        component: ComponentCreator('/docs/datamarketplace-api/list-all-data-disclosure-agreement-records/', 'e7d'),
        exact: true
      },
      {
        path: '/docs/datamarketplace-api/list-all-revisions-for-all-data-disclosure-agreement-records/',
        component: ComponentCreator('/docs/datamarketplace-api/list-all-revisions-for-all-data-disclosure-agreement-records/', 'af2'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/datamarketplace-api/list-data-disclosure-agreement-record-revisions/',
        component: ComponentCreator('/docs/datamarketplace-api/list-data-disclosure-agreement-record-revisions/', '0fe'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/datamarketplace-api/list-data-disclosure-agreement-template-revisions/',
        component: ComponentCreator('/docs/datamarketplace-api/list-data-disclosure-agreement-template-revisions/', '071'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/datamarketplace-api/list-data-disclosure-agreement-templates/',
        component: ComponentCreator('/docs/datamarketplace-api/list-data-disclosure-agreement-templates/', '7b0'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/datamarketplace-api/list-o-auth-2-0-clients/',
        component: ComponentCreator('/docs/datamarketplace-api/list-o-auth-2-0-clients/', '311'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/datamarketplace-api/list-pull-data-records/',
        component: ComponentCreator('/docs/datamarketplace-api/list-pull-data-records/', 'f9e'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/datamarketplace-api/list-validate-access-records/',
        component: ComponentCreator('/docs/datamarketplace-api/list-validate-access-records/', '335'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/datamarketplace-api/pull-data-endpoint/',
        component: ComponentCreator('/docs/datamarketplace-api/pull-data-endpoint/', '2ca'),
        exact: true
      },
      {
        path: '/docs/datamarketplace-api/read-access-point-configuration/',
        component: ComponentCreator('/docs/datamarketplace-api/read-access-point-configuration/', '2ca'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/datamarketplace-api/read-base-configurations/',
        component: ComponentCreator('/docs/datamarketplace-api/read-base-configurations/', '00f'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/datamarketplace-api/read-data-disclosure-agreement-record-revision/',
        component: ComponentCreator('/docs/datamarketplace-api/read-data-disclosure-agreement-record-revision/', '253'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/datamarketplace-api/read-data-disclosure-agreement-record/',
        component: ComponentCreator('/docs/datamarketplace-api/read-data-disclosure-agreement-record/', '6b9'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/datamarketplace-api/read-data-disclosure-agreement-template-revision/',
        component: ComponentCreator('/docs/datamarketplace-api/read-data-disclosure-agreement-template-revision/', '89d'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/datamarketplace-api/read-data-disclosure-agreement-template/',
        component: ComponentCreator('/docs/datamarketplace-api/read-data-disclosure-agreement-template/', '340'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/datamarketplace-api/read-o-auth-2-0-client/',
        component: ComponentCreator('/docs/datamarketplace-api/read-o-auth-2-0-client/', 'a5c'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/datamarketplace-api/read-pull-data-record/',
        component: ComponentCreator('/docs/datamarketplace-api/read-pull-data-record/', 'a30'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/datamarketplace-api/read-validate-access-record/',
        component: ComponentCreator('/docs/datamarketplace-api/read-validate-access-record/', 'e70'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/datamarketplace-api/update-base-configurations/',
        component: ComponentCreator('/docs/datamarketplace-api/update-base-configurations/', '89b'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/datamarketplace-api/update-data-disclosure-agreement-template/',
        component: ComponentCreator('/docs/datamarketplace-api/update-data-disclosure-agreement-template/', '8d2'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/datamarketplace-api/update-o-auth-2-0-client/',
        component: ComponentCreator('/docs/datamarketplace-api/update-o-auth-2-0-client/', 'def'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/datamarketplace-individual-api/access-point-configurations/',
        component: ComponentCreator('/docs/datamarketplace-individual-api/access-point-configurations/', '5d9'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/datamarketplace-individual-api/authorisation-server-metadata/',
        component: ComponentCreator('/docs/datamarketplace-individual-api/authorisation-server-metadata/', 'be9'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/datamarketplace-individual-api/get-individual-is-opted-in/',
        component: ComponentCreator('/docs/datamarketplace-individual-api/get-individual-is-opted-in/', '44a'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/datamarketplace-individual-api/igrant-io-api-documentation/',
        component: ComponentCreator('/docs/datamarketplace-individual-api/igrant-io-api-documentation/', '5d2'),
        exact: true
      },
      {
        path: '/docs/datamarketplace-individual-api/list-all-data-disclosure-agreement-records/',
        component: ComponentCreator('/docs/datamarketplace-individual-api/list-all-data-disclosure-agreement-records/', '3de'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/datamarketplace-individual-api/list-opted-in-individuals/',
        component: ComponentCreator('/docs/datamarketplace-individual-api/list-opted-in-individuals/', '306'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/datamarketplace-individual-api/pull-data-endpoint/',
        component: ComponentCreator('/docs/datamarketplace-individual-api/pull-data-endpoint/', '71e'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/datamarketplace-individual-api/token-verification-and-authorisation/',
        component: ComponentCreator('/docs/datamarketplace-individual-api/token-verification-and-authorisation/', '672'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/dcql-2-4-2-claim-set-age-verification/',
        component: ComponentCreator('/docs/dcql-2-4-2-claim-set-age-verification/', '69d'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/dcql-2-4-3-credential-set-proof-of-identity-alternatives/',
        component: ComponentCreator('/docs/dcql-2-4-3-credential-set-proof-of-identity-alternatives/', 'da1'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/dcql-2-4-4-kyc-request-photo-id-address-proof/',
        component: ComponentCreator('/docs/dcql-2-4-4-kyc-request-photo-id-address-proof/', 'c8f'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/dcql-2-4-5-student-transport-pass/',
        component: ComponentCreator('/docs/dcql-2-4-5-student-transport-pass/', 'd9e'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/dcql-2-4-6-loan-application-multiple-bank-statements/',
        component: ComponentCreator('/docs/dcql-2-4-6-loan-application-multiple-bank-statements/', 'f0a'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/dcql-2-4-7-delivery-service-restricted-postal-codes/',
        component: ComponentCreator('/docs/dcql-2-4-7-delivery-service-restricted-postal-codes/', '3b4'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/dcql-basic-credential-query-with-trusted-authority/',
        component: ComponentCreator('/docs/dcql-basic-credential-query-with-trusted-authority/', '5bd'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/dcql-overview/',
        component: ComponentCreator('/docs/dcql-overview/', 'a4b'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/developer-apis/',
        component: ComponentCreator('/docs/developer-apis/', '246'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/developer-apis/get-started/',
        component: ComponentCreator('/docs/developer-apis/get-started/', '35f'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/devtools-certificate-generator/',
        component: ComponentCreator('/docs/devtools-certificate-generator/', '175'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/devtools-certificate-viewer/',
        component: ComponentCreator('/docs/devtools-certificate-viewer/', 'cd6'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/devtools-json-schema-validator/',
        component: ComponentCreator('/docs/devtools-json-schema-validator/', 'be5'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/devtools-jwt-decoder/',
        component: ComponentCreator('/docs/devtools-jwt-decoder/', 'd7d'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/devtools-mdoc-decoder/',
        component: ComponentCreator('/docs/devtools-mdoc-decoder/', '778'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/devtools-overview/',
        component: ComponentCreator('/docs/devtools-overview/', '4e6'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/devtools-qrcode-decoder/',
        component: ComponentCreator('/docs/devtools-qrcode-decoder/', '0bb'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/devtools-qrcode-generator/',
        component: ComponentCreator('/docs/devtools-qrcode-generator/', 'da4'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/docx/',
        component: ComponentCreator('/docs/docx/', 'e68'),
        exact: true
      },
      {
        path: '/docs/drv-bund-api/admin-login/',
        component: ComponentCreator('/docs/drv-bund-api/admin-login/', '37a'),
        exact: true,
        sidebar: "drvBundSidebar"
      },
      {
        path: '/docs/drv-bund-api/drv-bund-controller-api-documentation/',
        component: ComponentCreator('/docs/drv-bund-api/drv-bund-controller-api-documentation/', '589'),
        exact: true
      },
      {
        path: '/docs/drv-bund-api/drv-bund-overview/',
        component: ComponentCreator('/docs/drv-bund-api/drv-bund-overview/', 'ae6'),
        exact: true,
        sidebar: "drvBundSidebar"
      },
      {
        path: '/docs/drv-bund-api/refresh-access-token/',
        component: ComponentCreator('/docs/drv-bund-api/refresh-access-token/', 'b5f'),
        exact: true,
        sidebar: "drvBundSidebar"
      },
      {
        path: '/docs/drv-bund-api/upload-ehic/',
        component: ComponentCreator('/docs/drv-bund-api/upload-ehic/', 'f9d'),
        exact: true,
        sidebar: "drvBundSidebar"
      },
      {
        path: '/docs/drv-bund-api/upload-pda-1/',
        component: ComponentCreator('/docs/drv-bund-api/upload-pda-1/', '8ef'),
        exact: true,
        sidebar: "drvBundSidebar"
      },
      {
        path: '/docs/ecosystem-engagements/eudi-wallet-pilots-and-deployments/',
        component: ComponentCreator('/docs/ecosystem-engagements/eudi-wallet-pilots-and-deployments/', 'ddc'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/ecosystem-engagements/interoperability-and-compliance/',
        component: ComponentCreator('/docs/ecosystem-engagements/interoperability-and-compliance/', 'a04'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/ecosystem-engagements/we-build-consortium/',
        component: ComponentCreator('/docs/ecosystem-engagements/we-build-consortium/', 'aee'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/eu-age-verification/',
        component: ComponentCreator('/docs/eu-age-verification/', 'ad0'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/eudi-passwordless-login-flow/',
        component: ComponentCreator('/docs/eudi-passwordless-login-flow/', 'ec9'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/european-business-wallet-owner-id/',
        component: ComponentCreator('/docs/european-business-wallet-owner-id/', '94c'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/extensions-api/config-create-digital-wallet-open-id-upload-file/',
        component: ComponentCreator('/docs/extensions-api/config-create-digital-wallet-open-id-upload-file/', '0fb'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/extensions-api/config-delete-digital-wallet-open-id-file/',
        component: ComponentCreator('/docs/extensions-api/config-delete-digital-wallet-open-id-file/', '5f0'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/extensions-api/config-list-digital-wallet-open-id-file/',
        component: ComponentCreator('/docs/extensions-api/config-list-digital-wallet-open-id-file/', '695'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/extensions-api/config-read-digital-wallet-open-id-file/',
        component: ComponentCreator('/docs/extensions-api/config-read-digital-wallet-open-id-file/', 'f3e'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/extensions-api/create-oidc-client/',
        component: ComponentCreator('/docs/extensions-api/create-oidc-client/', '2a2'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/extensions-api/delete-oidc-client/',
        component: ComponentCreator('/docs/extensions-api/delete-oidc-client/', '8fc'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/extensions-api/get-oid-configuration/',
        component: ComponentCreator('/docs/extensions-api/get-oid-configuration/', 'cf0'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/extensions-api/get-oidc-auth-sandbox/',
        component: ComponentCreator('/docs/extensions-api/get-oidc-auth-sandbox/', '1cd'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/extensions-api/get-oidc-auth/',
        component: ComponentCreator('/docs/extensions-api/get-oidc-auth/', 'ed0'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/extensions-api/get-oidc-configuration-sandbox/',
        component: ComponentCreator('/docs/extensions-api/get-oidc-configuration-sandbox/', '993'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/extensions-api/get-oidcjwks-sandbox/',
        component: ComponentCreator('/docs/extensions-api/get-oidcjwks-sandbox/', '619'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/extensions-api/get-oidcjwks/',
        component: ComponentCreator('/docs/extensions-api/get-oidcjwks/', '25a'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/extensions-api/get-post-oidc-user-info-sandbox/',
        component: ComponentCreator('/docs/extensions-api/get-post-oidc-user-info-sandbox/', '135'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/extensions-api/get-post-oidc-user-info/',
        component: ComponentCreator('/docs/extensions-api/get-post-oidc-user-info/', 'ef0'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/extensions-api/igrant-io-api-documentation/',
        component: ComponentCreator('/docs/extensions-api/igrant-io-api-documentation/', 'ba4'),
        exact: true
      },
      {
        path: '/docs/extensions-api/list-extensions/',
        component: ComponentCreator('/docs/extensions-api/list-extensions/', 'd17'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/extensions-api/list-oidc-client/',
        component: ComponentCreator('/docs/extensions-api/list-oidc-client/', 'c2a'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/extensions-api/post-oidc-auth-sandbox/',
        component: ComponentCreator('/docs/extensions-api/post-oidc-auth-sandbox/', 'aba'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/extensions-api/post-oidc-auth/',
        component: ComponentCreator('/docs/extensions-api/post-oidc-auth/', '456'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/extensions-api/post-oidc-token-sandbox/',
        component: ComponentCreator('/docs/extensions-api/post-oidc-token-sandbox/', '8f1'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/extensions-api/post-oidc-token/',
        component: ComponentCreator('/docs/extensions-api/post-oidc-token/', 'a39'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/extensions-api/read-account-information-access-extension-ts-12/',
        component: ComponentCreator('/docs/extensions-api/read-account-information-access-extension-ts-12/', 'f7c'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/extensions-api/read-age-verification-with-eudi-wallet-extension/',
        component: ComponentCreator('/docs/extensions-api/read-age-verification-with-eudi-wallet-extension/', '120'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/extensions-api/read-document-signing-with-eudi-wallet-extension/',
        component: ComponentCreator('/docs/extensions-api/read-document-signing-with-eudi-wallet-extension/', '41b'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/extensions-api/read-kyc-with-eudi-wallet-extension/',
        component: ComponentCreator('/docs/extensions-api/read-kyc-with-eudi-wallet-extension/', '37f'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/extensions-api/read-oidc-client/',
        component: ComponentCreator('/docs/extensions-api/read-oidc-client/', '185'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/extensions-api/read-payment-authorisation-for-banks-ts-12-extension/',
        component: ComponentCreator('/docs/extensions-api/read-payment-authorisation-for-banks-ts-12-extension/', '487'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/extensions-api/read-payment-authorisation-for-merchants-ts-12-extension/',
        component: ComponentCreator('/docs/extensions-api/read-payment-authorisation-for-merchants-ts-12-extension/', 'a98'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/extensions-api/read-payment-credential-issuance-ts-12-extension/',
        component: ComponentCreator('/docs/extensions-api/read-payment-credential-issuance-ts-12-extension/', 'a02'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/extensions-api/read-photo-id-credential-issuance-extension/',
        component: ComponentCreator('/docs/extensions-api/read-photo-id-credential-issuance-extension/', '8ef'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/extensions-api/read-pid-credential-issuance-extension/',
        component: ComponentCreator('/docs/extensions-api/read-pid-credential-issuance-extension/', '8ac'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/extensions-api/read-recurring-payment-mandate-ts-12-extension/',
        component: ComponentCreator('/docs/extensions-api/read-recurring-payment-mandate-ts-12-extension/', '442'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/extensions-api/read-risk-based-authentication-extension-ts-12/',
        component: ComponentCreator('/docs/extensions-api/read-risk-based-authentication-extension-ts-12/', '90f'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/extensions-api/set-extension-enabled-state/',
        component: ComponentCreator('/docs/extensions-api/set-extension-enabled-state/', '1c5'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/extensions-api/update-age-verification-identity-credentials-with-eudi-wallet-extension/',
        component: ComponentCreator('/docs/extensions-api/update-age-verification-identity-credentials-with-eudi-wallet-extension/', 'd63'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/extensions-api/update-kyc-identity-credentials-with-eudi-wallet-extension/',
        component: ComponentCreator('/docs/extensions-api/update-kyc-identity-credentials-with-eudi-wallet-extension/', 'bb0'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/extensions-api/update-oidc-client/',
        component: ComponentCreator('/docs/extensions-api/update-oidc-client/', '722'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/extensions-api/update-payment-authorisation-for-banks-ts-12-extension/',
        component: ComponentCreator('/docs/extensions-api/update-payment-authorisation-for-banks-ts-12-extension/', '9a0'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/extensions-api/update-payment-authorisation-for-merchants-ts-12-extension/',
        component: ComponentCreator('/docs/extensions-api/update-payment-authorisation-for-merchants-ts-12-extension/', '54c'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/extensions-api/update-payment-credential-issuance-ts-12-extension/',
        component: ComponentCreator('/docs/extensions-api/update-payment-credential-issuance-ts-12-extension/', 'a06'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/extensions-api/update-recurring-payment-mandate-ts-12-extension/',
        component: ComponentCreator('/docs/extensions-api/update-recurring-payment-mandate-ts-12-extension/', '535'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/extensions/account-information-access/',
        component: ComponentCreator('/docs/extensions/account-information-access/', '3af'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/extensions/age-verification/',
        component: ComponentCreator('/docs/extensions/age-verification/', '033'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/extensions/document-signing/',
        component: ComponentCreator('/docs/extensions/document-signing/', '91d'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/extensions/know-your-customer/',
        component: ComponentCreator('/docs/extensions/know-your-customer/', '3a8'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/extensions/openid-conformance/',
        component: ComponentCreator('/docs/extensions/openid-conformance/', 'dcb'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/extensions/overview/',
        component: ComponentCreator('/docs/extensions/overview/', '5c5'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/extensions/passwordless-login/',
        component: ComponentCreator('/docs/extensions/passwordless-login/', 'd68'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/extensions/payment-authorisation-for-banks/',
        component: ComponentCreator('/docs/extensions/payment-authorisation-for-banks/', '654'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/extensions/payment-authorisation-for-merchants/',
        component: ComponentCreator('/docs/extensions/payment-authorisation-for-merchants/', '051'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/extensions/payment-credential-issuance/',
        component: ComponentCreator('/docs/extensions/payment-credential-issuance/', '90c'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/extensions/photoid-credential-issuance/',
        component: ComponentCreator('/docs/extensions/photoid-credential-issuance/', 'e46'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/extensions/pid-credential-issuance/',
        component: ComponentCreator('/docs/extensions/pid-credential-issuance/', '0ef'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/extensions/recurring-payment-mandate/',
        component: ComponentCreator('/docs/extensions/recurring-payment-mandate/', '2b7'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/extensions/risk-based-authentication/',
        component: ComponentCreator('/docs/extensions/risk-based-authentication/', '4ee'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/get-started/',
        component: ComponentCreator('/docs/get-started/', 'ecc'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/intromain/',
        component: ComponentCreator('/docs/intromain/', '1d8'),
        exact: true
      },
      {
        path: '/docs/mdx/',
        component: ComponentCreator('/docs/mdx/', 'c0a'),
        exact: true
      },
      {
        path: '/docs/openid4vc-api/config-accept-digital-wallet-open-id-credential/',
        component: ComponentCreator('/docs/openid4vc-api/config-accept-digital-wallet-open-id-credential/', 'b6b'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-configure-auto-present-for-digital-wallet-open-id-credential/',
        component: ComponentCreator('/docs/openid4vc-api/config-configure-auto-present-for-digital-wallet-open-id-credential/', 'd7f'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-create-digital-wallet-open-id-credential-definition/',
        component: ComponentCreator('/docs/openid4vc-api/config-create-digital-wallet-open-id-credential-definition/', '836'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-create-digital-wallet-open-id-trust-authority/',
        component: ComponentCreator('/docs/openid4vc-api/config-create-digital-wallet-open-id-trust-authority/', 'e21'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-create-digital-wallet-open-id-verification-request-v-3/',
        component: ComponentCreator('/docs/openid4vc-api/config-create-digital-wallet-open-id-verification-request-v-3/', '66a'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-create-digital-wallet-open-id-wallet-unit/',
        component: ComponentCreator('/docs/openid4vc-api/config-create-digital-wallet-open-id-wallet-unit/', 'dce'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-create-sandbox-org/',
        component: ComponentCreator('/docs/openid4vc-api/config-create-sandbox-org/', '1a6'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-create-sse-ticket/',
        component: ComponentCreator('/docs/openid4vc-api/config-create-sse-ticket/', '8f9'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-create-webhook/',
        component: ComponentCreator('/docs/openid4vc-api/config-create-webhook/', 'aa7'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-delete-all-digital-wallet-open-id-notification/',
        component: ComponentCreator('/docs/openid4vc-api/config-delete-all-digital-wallet-open-id-notification/', '1ba'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-delete-digital-wallet-open-id-credential-definition/',
        component: ComponentCreator('/docs/openid4vc-api/config-delete-digital-wallet-open-id-credential-definition/', '381'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-delete-digital-wallet-open-id-credential-history/',
        component: ComponentCreator('/docs/openid4vc-api/config-delete-digital-wallet-open-id-credential-history/', '423'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-delete-digital-wallet-open-id-credential/',
        component: ComponentCreator('/docs/openid4vc-api/config-delete-digital-wallet-open-id-credential/', '889'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-delete-digital-wallet-open-id-notification/',
        component: ComponentCreator('/docs/openid4vc-api/config-delete-digital-wallet-open-id-notification/', 'bf4'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-delete-digital-wallet-open-id-presentation-definition/',
        component: ComponentCreator('/docs/openid4vc-api/config-delete-digital-wallet-open-id-presentation-definition/', 'dd9'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-delete-digital-wallet-open-id-trust-authority/',
        component: ComponentCreator('/docs/openid4vc-api/config-delete-digital-wallet-open-id-trust-authority/', '645'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-delete-digital-wallet-open-id-verification-history/',
        component: ComponentCreator('/docs/openid4vc-api/config-delete-digital-wallet-open-id-verification-history/', 'a5b'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-delete-digital-wallet-open-id-verification/',
        component: ComponentCreator('/docs/openid4vc-api/config-delete-digital-wallet-open-id-verification/', '484'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-delete-digital-wallet-open-id-wallet-unit/',
        component: ComponentCreator('/docs/openid4vc-api/config-delete-digital-wallet-open-id-wallet-unit/', 'ede'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-delete-sandbox-org/',
        component: ComponentCreator('/docs/openid4vc-api/config-delete-sandbox-org/', 'c1e'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-delete-webhook/',
        component: ComponentCreator('/docs/openid4vc-api/config-delete-webhook/', 'b36'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-deploy-digital-wallet-open-id/',
        component: ComponentCreator('/docs/openid4vc-api/config-deploy-digital-wallet-open-id/', 'e14'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-digital-wallet-open-id-create-key-store/',
        component: ComponentCreator('/docs/openid4vc-api/config-digital-wallet-open-id-create-key-store/', '012'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-digital-wallet-open-id-create-key/',
        component: ComponentCreator('/docs/openid4vc-api/config-digital-wallet-open-id-create-key/', '6ce'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-digital-wallet-open-id-create-test-ca/',
        component: ComponentCreator('/docs/openid4vc-api/config-digital-wallet-open-id-create-test-ca/', '231'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-digital-wallet-open-id-create-test-certificate/',
        component: ComponentCreator('/docs/openid4vc-api/config-digital-wallet-open-id-create-test-certificate/', 'd87'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-digital-wallet-open-id-delete-certificate-chain/',
        component: ComponentCreator('/docs/openid4vc-api/config-digital-wallet-open-id-delete-certificate-chain/', '335'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-digital-wallet-open-id-delete-key-store/',
        component: ComponentCreator('/docs/openid4vc-api/config-digital-wallet-open-id-delete-key-store/', 'c46'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-digital-wallet-open-id-delete-key/',
        component: ComponentCreator('/docs/openid4vc-api/config-digital-wallet-open-id-delete-key/', '473'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-digital-wallet-open-id-exchange-code-and-receive-credential/',
        component: ComponentCreator('/docs/openid4vc-api/config-digital-wallet-open-id-exchange-code-and-receive-credential/', '5e3'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-digital-wallet-open-id-generate-csr/',
        component: ComponentCreator('/docs/openid4vc-api/config-digital-wallet-open-id-generate-csr/', '49f'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-digital-wallet-open-id-import-key/',
        component: ComponentCreator('/docs/openid4vc-api/config-digital-wallet-open-id-import-key/', '2a8'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-digital-wallet-open-id-issue-credential/',
        component: ComponentCreator('/docs/openid4vc-api/config-digital-wallet-open-id-issue-credential/', '951'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-digital-wallet-open-id-key-trust-lookup/',
        component: ComponentCreator('/docs/openid4vc-api/config-digital-wallet-open-id-key-trust-lookup/', '72f'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-digital-wallet-open-id-list-certificate-presets/',
        component: ComponentCreator('/docs/openid4vc-api/config-digital-wallet-open-id-list-certificate-presets/', '787'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-digital-wallet-open-id-list-credential-categories/',
        component: ComponentCreator('/docs/openid4vc-api/config-digital-wallet-open-id-list-credential-categories/', '8b6'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-digital-wallet-open-id-list-key-store-types/',
        component: ComponentCreator('/docs/openid4vc-api/config-digital-wallet-open-id-list-key-store-types/', '707'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-digital-wallet-open-id-list-key-stores/',
        component: ComponentCreator('/docs/openid4vc-api/config-digital-wallet-open-id-list-key-stores/', 'ef3'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-digital-wallet-open-id-list-keys/',
        component: ComponentCreator('/docs/openid4vc-api/config-digital-wallet-open-id-list-keys/', '803'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-digital-wallet-open-id-list-provider-keys/',
        component: ComponentCreator('/docs/openid4vc-api/config-digital-wallet-open-id-list-provider-keys/', '26d'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-digital-wallet-open-id-presentation-definition/',
        component: ComponentCreator('/docs/openid4vc-api/config-digital-wallet-open-id-presentation-definition/', 'fd7'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-digital-wallet-open-id-read-issuer-metadata/',
        component: ComponentCreator('/docs/openid4vc-api/config-digital-wallet-open-id-read-issuer-metadata/', '8fd'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-digital-wallet-open-id-read-key-store/',
        component: ComponentCreator('/docs/openid4vc-api/config-digital-wallet-open-id-read-key-store/', '5dd'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-digital-wallet-open-id-read-key-usage/',
        component: ComponentCreator('/docs/openid4vc-api/config-digital-wallet-open-id-read-key-usage/', '532'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-digital-wallet-open-id-read-key/',
        component: ComponentCreator('/docs/openid4vc-api/config-digital-wallet-open-id-read-key/', '880'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-digital-wallet-open-id-read-test-ca/',
        component: ComponentCreator('/docs/openid4vc-api/config-digital-wallet-open-id-read-test-ca/', '542'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-digital-wallet-open-id-test-key-store/',
        component: ComponentCreator('/docs/openid4vc-api/config-digital-wallet-open-id-test-key-store/', '9e0'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-digital-wallet-open-id-update-key-store/',
        component: ComponentCreator('/docs/openid4vc-api/config-digital-wallet-open-id-update-key-store/', '918'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-digital-wallet-open-id-update-key/',
        component: ComponentCreator('/docs/openid4vc-api/config-digital-wallet-open-id-update-key/', '29b'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-digital-wallet-open-id-upload-certificate-chain/',
        component: ComponentCreator('/docs/openid4vc-api/config-digital-wallet-open-id-upload-certificate-chain/', '1fd'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-digital-wallet-open-id-validate-transaction-data/',
        component: ComponentCreator('/docs/openid4vc-api/config-digital-wallet-open-id-validate-transaction-data/', 'd5e'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-filter-digital-wallet-open-id-verification/',
        component: ComponentCreator('/docs/openid4vc-api/config-filter-digital-wallet-open-id-verification/', '3cd'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-list-all-recent-webhook-deliveries/',
        component: ComponentCreator('/docs/openid4vc-api/config-list-all-recent-webhook-deliveries/', '003'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-list-digital-wallet-open-id-credential-definition-templates/',
        component: ComponentCreator('/docs/openid4vc-api/config-list-digital-wallet-open-id-credential-definition-templates/', 'd5b'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-list-digital-wallet-open-id-credential-definition/',
        component: ComponentCreator('/docs/openid4vc-api/config-list-digital-wallet-open-id-credential-definition/', '6c7'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-list-digital-wallet-open-id-credential-history/',
        component: ComponentCreator('/docs/openid4vc-api/config-list-digital-wallet-open-id-credential-history/', '580'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-list-digital-wallet-open-id-credential/',
        component: ComponentCreator('/docs/openid4vc-api/config-list-digital-wallet-open-id-credential/', 'b54'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-list-digital-wallet-open-id-notification-sse/',
        component: ComponentCreator('/docs/openid4vc-api/config-list-digital-wallet-open-id-notification-sse/', '3d6'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-list-digital-wallet-open-id-notification/',
        component: ComponentCreator('/docs/openid4vc-api/config-list-digital-wallet-open-id-notification/', 'f2f'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-list-digital-wallet-open-id-organisation-wallet-unit/',
        component: ComponentCreator('/docs/openid4vc-api/config-list-digital-wallet-open-id-organisation-wallet-unit/', 'd86'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-list-digital-wallet-open-id-performance-statistics/',
        component: ComponentCreator('/docs/openid4vc-api/config-list-digital-wallet-open-id-performance-statistics/', '157'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-list-digital-wallet-open-id-presentation-definition-templates/',
        component: ComponentCreator('/docs/openid4vc-api/config-list-digital-wallet-open-id-presentation-definition-templates/', 'c82'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-list-digital-wallet-open-id-presentation-definition/',
        component: ComponentCreator('/docs/openid4vc-api/config-list-digital-wallet-open-id-presentation-definition/', 'daf'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-list-digital-wallet-open-id-scopes/',
        component: ComponentCreator('/docs/openid4vc-api/config-list-digital-wallet-open-id-scopes/', '257'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-list-digital-wallet-open-id-transaction-data-templates/',
        component: ComponentCreator('/docs/openid4vc-api/config-list-digital-wallet-open-id-transaction-data-templates/', 'b45'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-list-digital-wallet-open-id-transaction-data/',
        component: ComponentCreator('/docs/openid4vc-api/config-list-digital-wallet-open-id-transaction-data/', '5ae'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-list-digital-wallet-open-id-trust-authority/',
        component: ComponentCreator('/docs/openid4vc-api/config-list-digital-wallet-open-id-trust-authority/', 'f2e'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-list-digital-wallet-open-id-verification-history-v-3/',
        component: ComponentCreator('/docs/openid4vc-api/config-list-digital-wallet-open-id-verification-history-v-3/', '7d0'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-list-digital-wallet-open-id-verification-v-3/',
        component: ComponentCreator('/docs/openid4vc-api/config-list-digital-wallet-open-id-verification-v-3/', 'e17'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-list-digital-wallet-open-id-wallet-unit/',
        component: ComponentCreator('/docs/openid4vc-api/config-list-digital-wallet-open-id-wallet-unit/', '109'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-list-sandbox-orgs/',
        component: ComponentCreator('/docs/openid4vc-api/config-list-sandbox-orgs/', 'f46'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-list-webhooks/',
        component: ComponentCreator('/docs/openid4vc-api/config-list-webhooks/', 'beb'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-ping-webhook/',
        component: ComponentCreator('/docs/openid4vc-api/config-ping-webhook/', '041'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-preview-digital-wallet-open-id-credential-definition/',
        component: ComponentCreator('/docs/openid4vc-api/config-preview-digital-wallet-open-id-credential-definition/', '2bd'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-read-admin-authentication/',
        component: ComponentCreator('/docs/openid4vc-api/config-read-admin-authentication/', 'cad'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-read-admin-avatar/',
        component: ComponentCreator('/docs/openid4vc-api/config-read-admin-avatar/', 'eb2'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-read-admin-profile/',
        component: ComponentCreator('/docs/openid4vc-api/config-read-admin-profile/', 'b28'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-read-digital-wallet-open-id-credential-cover-image/',
        component: ComponentCreator('/docs/openid4vc-api/config-read-digital-wallet-open-id-credential-cover-image/', 'd0b'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-read-digital-wallet-open-id-credential-definition/',
        component: ComponentCreator('/docs/openid4vc-api/config-read-digital-wallet-open-id-credential-definition/', 'e0d'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-read-digital-wallet-open-id-credential-history/',
        component: ComponentCreator('/docs/openid4vc-api/config-read-digital-wallet-open-id-credential-history/', '475'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-read-digital-wallet-open-id-credential-logo-image/',
        component: ComponentCreator('/docs/openid4vc-api/config-read-digital-wallet-open-id-credential-logo-image/', '446'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-read-digital-wallet-open-id-credential-revocation-status/',
        component: ComponentCreator('/docs/openid4vc-api/config-read-digital-wallet-open-id-credential-revocation-status/', '770'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-read-digital-wallet-open-id-credential/',
        component: ComponentCreator('/docs/openid4vc-api/config-read-digital-wallet-open-id-credential/', 'b29'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-read-digital-wallet-open-id-global-configuration/',
        component: ComponentCreator('/docs/openid4vc-api/config-read-digital-wallet-open-id-global-configuration/', 'c5c'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-read-digital-wallet-open-id-holder-global-configuration/',
        component: ComponentCreator('/docs/openid4vc-api/config-read-digital-wallet-open-id-holder-global-configuration/', '086'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-read-digital-wallet-open-id-notification/',
        component: ComponentCreator('/docs/openid4vc-api/config-read-digital-wallet-open-id-notification/', '063'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-read-digital-wallet-open-id-presentation-definition/',
        component: ComponentCreator('/docs/openid4vc-api/config-read-digital-wallet-open-id-presentation-definition/', '317'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-read-digital-wallet-open-id-presentation-status-sse/',
        component: ComponentCreator('/docs/openid4vc-api/config-read-digital-wallet-open-id-presentation-status-sse/', '78e'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-read-digital-wallet-open-id-transaction-data/',
        component: ComponentCreator('/docs/openid4vc-api/config-read-digital-wallet-open-id-transaction-data/', '61a'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-read-digital-wallet-open-id-trust-authority/',
        component: ComponentCreator('/docs/openid4vc-api/config-read-digital-wallet-open-id-trust-authority/', 'a3d'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-read-digital-wallet-open-id-verification-history-v-3/',
        component: ComponentCreator('/docs/openid4vc-api/config-read-digital-wallet-open-id-verification-history-v-3/', 'e8b'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-read-digital-wallet-open-id-verification-v-3/',
        component: ComponentCreator('/docs/openid4vc-api/config-read-digital-wallet-open-id-verification-v-3/', 'a76'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-read-digital-wallet-open-id-verifier-global-configuration/',
        component: ComponentCreator('/docs/openid4vc-api/config-read-digital-wallet-open-id-verifier-global-configuration/', '992'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-read-digital-wallet-open-id-wallet-unit-status/',
        component: ComponentCreator('/docs/openid4vc-api/config-read-digital-wallet-open-id-wallet-unit-status/', '70c'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-read-digital-wallet-open-id-wallet-unit/',
        component: ComponentCreator('/docs/openid4vc-api/config-read-digital-wallet-open-id-wallet-unit/', 'a2b'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-read-digital-wallet-open-id/',
        component: ComponentCreator('/docs/openid4vc-api/config-read-digital-wallet-open-id/', 'ef0'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-read-recent-webhook-delivery/',
        component: ComponentCreator('/docs/openid4vc-api/config-read-recent-webhook-delivery/', '84e'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-read-sandbox-org/',
        component: ComponentCreator('/docs/openid4vc-api/config-read-sandbox-org/', 'e9f'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-read-webhook-event-types/',
        component: ComponentCreator('/docs/openid4vc-api/config-read-webhook-event-types/', '8e1'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-read-webhook/',
        component: ComponentCreator('/docs/openid4vc-api/config-read-webhook/', 'a06'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-receive-deferred-digital-wallet-open-id-credential/',
        component: ComponentCreator('/docs/openid4vc-api/config-receive-deferred-digital-wallet-open-id-credential/', 'b86'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-receive-digital-wallet-open-id-credential/',
        component: ComponentCreator('/docs/openid4vc-api/config-receive-digital-wallet-open-id-credential/', '999'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-receive-digital-wallet-open-id-dc-api-response/',
        component: ComponentCreator('/docs/openid4vc-api/config-receive-digital-wallet-open-id-dc-api-response/', '2bc'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-receive-digital-wallet-open-id-verification-v-3/',
        component: ComponentCreator('/docs/openid4vc-api/config-receive-digital-wallet-open-id-verification-v-3/', '01f'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-receive-user-pin-for-digital-wallet-open-id-credential/',
        component: ComponentCreator('/docs/openid4vc-api/config-receive-user-pin-for-digital-wallet-open-id-credential/', '052'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-request-digital-wallet-open-id-credential-reissuance/',
        component: ComponentCreator('/docs/openid4vc-api/config-request-digital-wallet-open-id-credential-reissuance/', 'b5d'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-revalidate-digital-wallet-open-id-verification/',
        component: ComponentCreator('/docs/openid4vc-api/config-revalidate-digital-wallet-open-id-verification/', '219'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-send-digital-wallet-open-id-verification-presentation-v-3/',
        component: ComponentCreator('/docs/openid4vc-api/config-send-digital-wallet-open-id-verification-presentation-v-3/', '9df'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-toggle-digital-wallet-open-id-trust-authority/',
        component: ComponentCreator('/docs/openid4vc-api/config-toggle-digital-wallet-open-id-trust-authority/', '9fc'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-update-admin-avatar/',
        component: ComponentCreator('/docs/openid4vc-api/config-update-admin-avatar/', '2c2'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-update-admin-profile/',
        component: ComponentCreator('/docs/openid4vc-api/config-update-admin-profile/', '120'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-update-digital-wallet-open-id-credential-cover-image/',
        component: ComponentCreator('/docs/openid4vc-api/config-update-digital-wallet-open-id-credential-cover-image/', '485'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-update-digital-wallet-open-id-credential-definition/',
        component: ComponentCreator('/docs/openid4vc-api/config-update-digital-wallet-open-id-credential-definition/', '493'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-update-digital-wallet-open-id-credential-history/',
        component: ComponentCreator('/docs/openid4vc-api/config-update-digital-wallet-open-id-credential-history/', '01b'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-update-digital-wallet-open-id-credential-logo-image/',
        component: ComponentCreator('/docs/openid4vc-api/config-update-digital-wallet-open-id-credential-logo-image/', '9de'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-update-digital-wallet-open-id-credential-revocation-status/',
        component: ComponentCreator('/docs/openid4vc-api/config-update-digital-wallet-open-id-credential-revocation-status/', 'edd'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-update-digital-wallet-open-id-global-configuration-cover-image/',
        component: ComponentCreator('/docs/openid4vc-api/config-update-digital-wallet-open-id-global-configuration-cover-image/', '47e'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-update-digital-wallet-open-id-global-configuration-logo-image/',
        component: ComponentCreator('/docs/openid4vc-api/config-update-digital-wallet-open-id-global-configuration-logo-image/', '0b0'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-update-digital-wallet-open-id-global-configuration/',
        component: ComponentCreator('/docs/openid4vc-api/config-update-digital-wallet-open-id-global-configuration/', 'b37'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-update-digital-wallet-open-id-holder-global-configuration/',
        component: ComponentCreator('/docs/openid4vc-api/config-update-digital-wallet-open-id-holder-global-configuration/', 'e78'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-update-digital-wallet-open-id-notification/',
        component: ComponentCreator('/docs/openid4vc-api/config-update-digital-wallet-open-id-notification/', 'e19'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-update-digital-wallet-open-id-presentation-definition/',
        component: ComponentCreator('/docs/openid4vc-api/config-update-digital-wallet-open-id-presentation-definition/', '5da'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-update-digital-wallet-open-id-sandbox-org-cover/',
        component: ComponentCreator('/docs/openid4vc-api/config-update-digital-wallet-open-id-sandbox-org-cover/', '711'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-update-digital-wallet-open-id-sandbox-org-logo/',
        component: ComponentCreator('/docs/openid4vc-api/config-update-digital-wallet-open-id-sandbox-org-logo/', '16f'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-update-digital-wallet-open-id-sandbox-org-name/',
        component: ComponentCreator('/docs/openid4vc-api/config-update-digital-wallet-open-id-sandbox-org-name/', 'bd5'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-update-digital-wallet-open-id-trust-authority/',
        component: ComponentCreator('/docs/openid4vc-api/config-update-digital-wallet-open-id-trust-authority/', '53a'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-update-digital-wallet-open-id-verifier-global-configuration/',
        component: ComponentCreator('/docs/openid4vc-api/config-update-digital-wallet-open-id-verifier-global-configuration/', 'd33'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-update-digital-wallet-open-id-wallet-unit/',
        component: ComponentCreator('/docs/openid4vc-api/config-update-digital-wallet-open-id-wallet-unit/', '911'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-update-digital-wallet-open-id/',
        component: ComponentCreator('/docs/openid4vc-api/config-update-digital-wallet-open-id/', '857'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-update-sandbox-org/',
        component: ComponentCreator('/docs/openid4vc-api/config-update-sandbox-org/', '5f2'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/config-update-webhook/',
        component: ComponentCreator('/docs/openid4vc-api/config-update-webhook/', '9fc'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/get-webhook-payload-content-types/',
        component: ComponentCreator('/docs/openid4vc-api/get-webhook-payload-content-types/', '164'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openid4vc-api/igrant-io-api-documentation/',
        component: ComponentCreator('/docs/openid4vc-api/igrant-io-api-documentation/', '69d'),
        exact: true,
        sidebar: "openApiSidebar"
      },
      {
        path: '/docs/openID4vc-dcapi-overview/',
        component: ComponentCreator('/docs/openID4vc-dcapi-overview/', 'd40'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/openid4vc-key-management/',
        component: ComponentCreator('/docs/openid4vc-key-management/', '54a'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/openID4vc-receive-and-store-credential/',
        component: ComponentCreator('/docs/openID4vc-receive-and-store-credential/', '3cc'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/openID4vc-send-verify-credentials-dcapi-android/',
        component: ComponentCreator('/docs/openID4vc-send-verify-credentials-dcapi-android/', '274'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/openID4vc-send-verify-credentials-dcapi-ios/',
        component: ComponentCreator('/docs/openID4vc-send-verify-credentials-dcapi-ios/', '613'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/openID4vc-send-verify-credentials/',
        component: ComponentCreator('/docs/openID4vc-send-verify-credentials/', 'cb5'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/openid4vc-webhooks/',
        component: ComponentCreator('/docs/openid4vc-webhooks/', 'f4d'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/openID4vci-issue-credential-deferred/',
        component: ComponentCreator('/docs/openID4vci-issue-credential-deferred/', 'a0f'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/openID4vci-issue-credential-intime/',
        component: ComponentCreator('/docs/openID4vci-issue-credential-intime/', '525'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/openID4vci-issue-dynamic-credential-request/',
        component: ComponentCreator('/docs/openID4vci-issue-dynamic-credential-request/', '798'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/openID4vci-payment-data-confirmation/',
        component: ComponentCreator('/docs/openID4vci-payment-data-confirmation/', '64b'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/openID4vci-payment-wallet-attestation/',
        component: ComponentCreator('/docs/openID4vci-payment-wallet-attestation/', '907'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/openID4vp-receive-and-present-credentials/',
        component: ComponentCreator('/docs/openID4vp-receive-and-present-credentials/', 'deb'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/organisation-wallet-features/',
        component: ComponentCreator('/docs/organisation-wallet-features/', '44e'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/organisation-wallet-on-premise-deployment/',
        component: ComponentCreator('/docs/organisation-wallet-on-premise-deployment/', '02e'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/organisation-wallet-overview/',
        component: ComponentCreator('/docs/organisation-wallet-overview/', '371'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/platform-admin-guide/',
        component: ComponentCreator('/docs/platform-admin-guide/', '395'),
        exact: true
      },
      {
        path: '/docs/references/',
        component: ComponentCreator('/docs/references/', 'd7c'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/sandbox-organisations/',
        component: ComponentCreator('/docs/sandbox-organisations/', '09d'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/terminology/',
        component: ComponentCreator('/docs/terminology/', '870'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/trust-overview/',
        component: ComponentCreator('/docs/trust-overview/', '77c'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/trust-relying-party-registration/',
        component: ComponentCreator('/docs/trust-relying-party-registration/', 'bad'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/trust-untrusted-service-provider/',
        component: ComponentCreator('/docs/trust-untrusted-service-provider/', '912'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/ts12-account-information-access/',
        component: ComponentCreator('/docs/ts12-account-information-access/', '367'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/ts12-emandate/',
        component: ComponentCreator('/docs/ts12-emandate/', '4f7'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/ts12-overview/',
        component: ComponentCreator('/docs/ts12-overview/', '5ef'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/ts12-payment-authorisation/',
        component: ComponentCreator('/docs/ts12-payment-authorisation/', 'd62'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/docs/ts12-risk-based-authentication/',
        component: ComponentCreator('/docs/ts12-risk-based-authentication/', '2d0'),
        exact: true,
        sidebar: "docs"
      }
    ]
  },
  {
    path: '/regulations/',
    component: ComponentCreator('/regulations/', '5a8'),
    routes: [
      {
        path: '/regulations/',
        component: ComponentCreator('/regulations/', '0df'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/regulations/implementing-acts-accreditation-conformity/',
        component: ComponentCreator('/regulations/implementing-acts-accreditation-conformity/', '933'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/regulations/implementing-acts-annual-reports/',
        component: ComponentCreator('/regulations/implementing-acts-annual-reports/', 'b35'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/regulations/implementing-acts-certification/',
        component: ComponentCreator('/regulations/implementing-acts-certification/', '120'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/regulations/implementing-acts-certified-creation-devices/',
        component: ComponentCreator('/regulations/implementing-acts-certified-creation-devices/', '4a2'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/regulations/implementing-acts-cross-border-identity/',
        component: ComponentCreator('/regulations/implementing-acts-cross-border-identity/', '641'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/regulations/implementing-acts-formats-signatures-seals/',
        component: ComponentCreator('/regulations/implementing-acts-formats-signatures-seals/', 'b71'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/regulations/implementing-acts-identity-qualified-certificates/',
        component: ComponentCreator('/regulations/implementing-acts-identity-qualified-certificates/', '8dd'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/regulations/implementing-acts-integrity-and-core-functions/',
        component: ComponentCreator('/regulations/implementing-acts-integrity-and-core-functions/', '836'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/regulations/implementing-acts-list-certificates/',
        component: ComponentCreator('/regulations/implementing-acts-list-certificates/', '04b'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/regulations/implementing-acts-overview/',
        component: ComponentCreator('/regulations/implementing-acts-overview/', 'c82'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/regulations/implementing-acts-peer-review-eid/',
        component: ComponentCreator('/regulations/implementing-acts-peer-review-eid/', '37e'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/regulations/implementing-acts-pid-and-eaass/',
        component: ComponentCreator('/regulations/implementing-acts-pid-and-eaass/', 'f0d'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/regulations/implementing-acts-protocols-and-interfaces-to-be-supported/',
        component: ComponentCreator('/regulations/implementing-acts-protocols-and-interfaces-to-be-supported/', '4e6'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/regulations/implementing-acts-qualified-certificates/',
        component: ComponentCreator('/regulations/implementing-acts-qualified-certificates/', '053'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/regulations/implementing-acts-qualified-delivery/',
        component: ComponentCreator('/regulations/implementing-acts-qualified-delivery/', 'e73'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/regulations/implementing-acts-qualified-electronic-archiving/',
        component: ComponentCreator('/regulations/implementing-acts-qualified-electronic-archiving/', 'aba'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/regulations/implementing-acts-qualified-electronic-ledgers/',
        component: ComponentCreator('/regulations/implementing-acts-qualified-electronic-ledgers/', '63f'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/regulations/implementing-acts-qualified-preservation/',
        component: ComponentCreator('/regulations/implementing-acts-qualified-preservation/', 'daf'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/regulations/implementing-acts-qualified-timestamps/',
        component: ComponentCreator('/regulations/implementing-acts-qualified-timestamps/', 'd39'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/regulations/implementing-acts-qualified-trust-apps/',
        component: ComponentCreator('/regulations/implementing-acts-qualified-trust-apps/', '7f5'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/regulations/implementing-acts-qualified-trust-service-providers/',
        component: ComponentCreator('/regulations/implementing-acts-qualified-trust-service-providers/', '589'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/regulations/implementing-acts-qualified-website-auth-certs/',
        component: ComponentCreator('/regulations/implementing-acts-qualified-website-auth-certs/', '587'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/regulations/implementing-acts-recognition-validation/',
        component: ComponentCreator('/regulations/implementing-acts-recognition-validation/', '699'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/regulations/implementing-acts-reference-standards/',
        component: ComponentCreator('/regulations/implementing-acts-reference-standards/', '542'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/regulations/implementing-acts-registration-relying-parties-update/',
        component: ComponentCreator('/regulations/implementing-acts-registration-relying-parties-update/', '0c2'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/regulations/implementing-acts-registration-relying-parties/',
        component: ComponentCreator('/regulations/implementing-acts-registration-relying-parties/', '482'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/regulations/implementing-acts-remote-creation-devices/',
        component: ComponentCreator('/regulations/implementing-acts-remote-creation-devices/', 'c9b'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/regulations/implementing-acts-remote-onboarding/',
        component: ComponentCreator('/regulations/implementing-acts-remote-onboarding/', 'cb2'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/regulations/implementing-acts-risk-management/',
        component: ComponentCreator('/regulations/implementing-acts-risk-management/', '248'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/regulations/implementing-acts-security-breaches/',
        component: ComponentCreator('/regulations/implementing-acts-security-breaches/', '335'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/regulations/implementing-acts-trusted-lists/',
        component: ComponentCreator('/regulations/implementing-acts-trusted-lists/', '11d'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/regulations/implementing-acts-trustframework/',
        component: ComponentCreator('/regulations/implementing-acts-trustframework/', '99b'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/regulations/implementing-acts-verification-attestations-update/',
        component: ComponentCreator('/regulations/implementing-acts-verification-attestations-update/', 'ff2'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/regulations/implementing-acts-verification-attestations/',
        component: ComponentCreator('/regulations/implementing-acts-verification-attestations/', '0fd'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/regulations/implementing-acts-wallet-standards-update/',
        component: ComponentCreator('/regulations/implementing-acts-wallet-standards-update/', 'a63'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/regulations/reg-eu-business-wallets/',
        component: ComponentCreator('/regulations/reg-eu-business-wallets/', '055'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/regulations/reg-eu-data-act/',
        component: ComponentCreator('/regulations/reg-eu-data-act/', '873'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/regulations/reg-eu-data-governance-act/',
        component: ComponentCreator('/regulations/reg-eu-data-governance-act/', '0f2'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/regulations/reg-eu-digital-id-framework/',
        component: ComponentCreator('/regulations/reg-eu-digital-id-framework/', '502'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/regulations/reg-eu-gdpr/',
        component: ComponentCreator('/regulations/reg-eu-gdpr/', '74b'),
        exact: true,
        sidebar: "docs"
      },
      {
        path: '/regulations/reg-eu-health-data-space/',
        component: ComponentCreator('/regulations/reg-eu-health-data-space/', '897'),
        exact: true,
        sidebar: "docs"
      }
    ]
  },
  {
    path: '/schema/',
    component: ComponentCreator('/schema/', '011'),
    routes: [
      {
        path: '/schema/data-agreements/v1.0/',
        component: ComponentCreator('/schema/data-agreements/v1.0/', 'bef'),
        exact: true,
        sidebar: "daSidebar"
      },
      {
        path: '/schema/data-agreements/v1.1/',
        component: ComponentCreator('/schema/data-agreements/v1.1/', '33b'),
        exact: true,
        sidebar: "daSidebar"
      },
      {
        path: '/schema/data-disclosure-agreements/v1.0/',
        component: ComponentCreator('/schema/data-disclosure-agreements/v1.0/', '538'),
        exact: true,
        sidebar: "ddaSidebar"
      }
    ]
  },
  {
    path: '/',
    component: ComponentCreator('/', '92f'),
    exact: true
  },
  {
    path: '*',
    component: ComponentCreator('*'),
  },
];
